module.exports = __webpack_public_path__ + "img/all-done.8114aced.svg";